import { Group } from '@mantine/core';
import { DateInput } from '@mantine/dates';

import { LABELS } from '../../constants';

import { PlatformsSelect } from '@/components';
import { Platforms } from '@/types';

type Props = {
  date: Date;
  platform: Platforms;
  setSelectedDate: (value: Date) => void;
  setPlatform: (value: Platforms) => void;
};

export const RequestsControlsPanel = ({ date, platform, setPlatform, setSelectedDate }: Props) => {
  return (
    <Group className="selectors-wrapper" justify="center" align="end" mb="xl">
      <DateInput
        value={date}
        placeholder={LABELS.SELECT_DATE}
        label={LABELS.STATISTIC_DATE}
        onChange={(value) => {
          if (value) {
            setSelectedDate(value as Date);
          }
        }}
      />
      <PlatformsSelect label={LABELS.PLATFORM} value={platform} onSelect={setPlatform} />
    </Group>
  );
};
